/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAMoveIcon16Solid = forwardRef('UiCursorAMoveIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 8 2.25Z" }),
        React.createElement("path", { d: "M4.729 2.319c-1.12-.842-2.72-.044-2.722 1.357l-.01 9.388c-.003 1.634 2.076 2.33 3.058 1.023l2.25-2.992a.2.2 0 0 1 .16-.08l3.744.004c1.634.002 2.33-2.077 1.024-3.059L4.729 2.32Z" }),
        React.createElement("path", { d: "M11.75 4a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z" })));
});
